import { Button, Form, Input, message, Modal, Radio, Select, Row, Col, Divider } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import PswpComponent from 'src/components/common/PswpComponent';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IDoctorInfo, IDoctorOrderAdd, ISelectOption } from 'src/entity/DoctorEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { IRechargeInfo } from 'src/entity/RechargeEntity';
import { fetchDrugStoresIfNeeded, fixDrugStoreSettingData } from 'src/redux/actions/drugStoreCreator';
import DoctorService from 'src/services/DoctorService';
import { RouterConfig } from 'src/routers/urlConfig';
import I18N from 'src/services/I18NService';
import { UtilDateTime } from 'src/utils/datetime';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { fetchRechargeOptionsIfNeeded, filterRechargeOption, RechargeOptionList } from 'src/redux/actions/rechargeCreator';
import { IStateCollection } from 'src/entity/StateEntity';
import { RadioChangeEvent } from 'antd/lib/radio';
import PharmacySetting from 'src/containers/PharmacySetting';
import { IPharmacySettingData, pharmacySettingDataHandle, settingDataErrorMsg } from 'src/components/common/PharmacySetting';
import { MallService } from 'src/services/MallService';
import { settingData2OnlineData, cloudSettingInfo2Source, localSettingInfo2Source } from 'src/redux/actions/mallPharmacyCreator';
import PrescriptionRightForm from './PrescriptionRightForm';
import { IPropsLocationState } from 'src/entity/SearchEntity';
import { IMallPharmacySettingInfo } from 'src/entity/MallEntity';
import { getLocationNameChain } from 'src/redux/actions/locationCreator';

const confirm = Modal.confirm;

interface IDoctorDetailFormProps extends FormComponentProps, RouteComponentProps<{}, {}, IPropsLocationState> {
  isAgent: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  isDomestic: boolean;
  drugStores: IDrugStoreInfo[];
  detailType: ActionTypes.DOCTOR_DETAIL_SOURCE;
  doctorInfo: IDoctorInfo;
  rechargeList: IRechargeInfo[];
  dispatch: Dispatch<IStateCollection>;
}
interface IDoctorDetailPageState {
  /** 控制模态窗显示/隐藏 */
  modalVisible: boolean;
  /** 药库设置的数据 */
  settingData: IPharmacySettingData;
  /** 本地药房设置的数据 */
  localSettingData: IMallPharmacySettingInfo[];
  /** loading状态 */
  isLoading: boolean;
}

class DoctorDetailForm extends React.Component<IDoctorDetailFormProps, IDoctorDetailPageState> {
  childPswp: any;
  /** 上级机构诊所选项列表 */
  superiorHospitalOptions: ISelectOption[] = [];
  // /** 上级医生选项列表 */
  // superiorDoctorOptions: ISelectOption[] = [];
  /** 临时解决AntUI Radio.Button内部bug，onChange执行2次  */
  canSendPrescriptionRightMsg = true;

  constructor(props: IDoctorDetailFormProps) {
    super(props);

    this.state = {
      modalVisible: false,
      settingData: {
        isOrderOnline: false,
        onlineDataList: [],
        offlineDataList: [],
        localDataList: [],
        defaultMedicinePharmacy: undefined,
        defaultPrescriptionPharmacy: undefined,
      },
      localSettingData: [],
      isLoading: false,
    } as IDoctorDetailPageState;
  }

  async UNSAFE_componentWillMount() {
    const { doctorInfo } = this.props;
    if (doctorInfo.certification_level > 0) {
      // 医生用户(职业医生|乡村医生|海外医生)
      await this.getSuperiorSelectOptions();
    }
    // 获取代理商的配药中心
    await this.props.dispatch(fetchDrugStoresIfNeeded());
    // 获取充值选项
    await this.props.dispatch(fetchRechargeOptionsIfNeeded());
  }

  async componentDidMount() {
    const { doctorInfo, drugStores, isAgent } = this.props;
    if (!!doctorInfo && !!doctorInfo.buyer_user) {
      // 获取医生的单元药库设置
      const dataPharmacyList = await MallService.getCloudPharmacySetting(doctorInfo.buyer_user);
      // 本地药房：获取医生的单元药库设置
      const localSettingList = await MallService.getLocalPharmacySetting(doctorInfo.buyer_user);
      // 获取医生的默认药库设置
      const configRes = await MallService.getDoctorMedicineConfig(doctorInfo.buyer_user);
      // 完善配药中心的数据
      const dataDrugStoreList = fixDrugStoreSettingData(drugStores, doctorInfo.drug_stores || []);
      // 将请求数据转换为界面所需的数据
      this.setState({
        settingData: {
          isOrderOnline: isAgent && dataDrugStoreList.length > 0,
          onlineDataList: settingData2OnlineData(
            {
              dataDrugStoreList,
              dataPharmacyList,
            },
            drugStores
          ),
          offlineDataList: cloudSettingInfo2Source(dataPharmacyList),
          localDataList: localSettingInfo2Source(localSettingList),
          defaultMedicinePharmacy: !!configRes ? configRes.order_cloud_medicine_group : undefined,
          defaultPrescriptionPharmacy: !!configRes ? configRes.prescription_cloud_medicine_group : undefined,
        },
        localSettingData: localSettingList,
      });
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 绑定子组件
   *
   * @memberof DoctorDetailForm
   */
  onRefBind = (ref: any) => {
    this.childPswp = ref;
  };

  /**
   * 查看图片
   *
   * @memberof DoctorDetailForm
   */
  openGallery = (item: string | undefined) => {
    if (!!item) {
      this.childPswp.openGallery(item);
    }
  };

  /**
   * 提交
   *
   * @memberof DoctorDetailForm
   */
  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    // this.checkMedicineSetting();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { doctorInfo, drugStores, detailType, isDomestic } = this.props;
        const { settingData } = this.state;

        // 药房设置显示时，验证药房设置是否正确
        if (detailType !== ActionTypes.DOCTOR_TYPE_REJECT && values.is_pass === 'true' && isDomestic) {
          const errorMsg = settingDataErrorMsg(settingData, drugStores, doctorInfo.location_id);
          if (!!errorMsg) {
            message.error(errorMsg);
            return;
          }
        }

        if (!!values.recharge && values.recharge > 0) {
          const rechargeObj = RechargeOptionList.find((r) => r.value === values.recharge);
          if (!!rechargeObj) {
            confirm({
              title: `${I18N.get('doc_add_to_user')}${I18N.get(rechargeObj.key)}?`,
              content: `${I18N.get('doc_warning_undone')}`,
              okText: I18N.get('common_ok'),
              cancelText: I18N.get('common_cancel'),
              onOk: () => this.doSubmit(values),
              onCancel() {},
            });
          }
        } else {
          this.doSubmit(values);
        }
      }
    });
  };

  /**
   * 提交
   *
   * @memberof DoctorDetailForm
   */
  doSubmit = async (values: any) => {
    const { detailType, doctorInfo } = this.props;
    if (!doctorInfo) {
      return;
    }
    if (detailType === ActionTypes.DOCTOR_TYPE_ISPASS) {
      if (values.is_pass === 'true') {
        // 调用审核接口(成功)
        this.doPass(values);
      } else {
        // 调用审核驳回接口
        this.doUnPass(doctorInfo, values.reason || 'null');
      }
    } else if (detailType === ActionTypes.DOCTOR_TYPE_ISCERTIFICATED) {
      // 先修改会诊相关数据
      const res = await this.doCertificationUpdateDoctorInfo(values);
      if (!res) {
        return;
      }

      // const data: ISubCertificationDoctorInfo = {
      //   status: values.is_certificated === 'true',
      //   fail_reason: values.is_certificated === 'true' ? 'success' : I18N.get('err_incomplete'),
      // };

      const isCertified = values.is_certificated === 'true';
      const reason = values.is_certificated === 'true' ? 'success' : I18N.get('err_incomplete');
      // const params: any = this.props.match.params;
      // 调用认证接口
      this.doCertification(isCertified, reason);
    }
  };

  /**
   * 显示模态窗
   *
   * @memberof DoctorDetailForm
   */
  showModal = () => {
    this.setState({
      modalVisible: true,
    });
  };

  /**
   * 关闭模态窗
   *
   * @memberof DoctorDetailForm
   */
  closeModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  /**
   * 检验是否有下级医生关联处方权
   *
   * @memberof DoctorDetailForm
   */
  checkPrescriptionRight = (e: RadioChangeEvent): boolean => {
    let prescriptionRight = e.target.value as boolean;
    if (prescriptionRight === false) {
      const { doctorInfo } = this.props;
      if (doctorInfo.has_sub_doctors) {
        // 有下级医生关联处方权， 不允许设为否
        prescriptionRight = true;
        if (this.canSendPrescriptionRightMsg) {
          this.canSendPrescriptionRightMsg = false;
          message.error(I18N.get('doc_prescription_right_note'));
          setTimeout(() => {
            this.canSendPrescriptionRightMsg = true;
          }, 100);
        }
      }
    }
    return prescriptionRight;
  };

  /**
   * 审核通过接口
   *
   * @memberof DoctorDetailForm
   */
  doPass = async (values: any) => {
    if (this.state.isLoading) {
      return;
    }
    try {
      const { doctorInfo, isAgent, drugStores } = this.props;
      const { settingData } = this.state;
      if (!doctorInfo) {
        return;
      }

      this.setState({
        isLoading: true,
      });
      doctorInfo.is_certificated = values.is_certificated === 'true';
      doctorInfo.agent_discount = 0;
      // doctorInfo.agent_salesman = values.agent_salesman;

      // 处理处方权相关字段
      const isDoctorUser = doctorInfo.certification_level > 0;
      if (isDoctorUser) {
        doctorInfo.prescription_right = values.prescription_right;
        doctorInfo.superior_institution = values.superior_hospital;
        doctorInfo.cooperative_diagnosis_opened = values.cooperative_diagnosis_opened;
      } else {
        // [学习用户&&业务员] 处方权默认设置false
        doctorInfo.prescription_right = false;
        doctorInfo.superior_institution = null;
      }

      if (!!isAgent && !!doctorInfo.id && !!doctorInfo.buyer_user && !!settingData) {
        let res = true;
        // 1、调用认证接口
        res = res && !!(await DoctorService.changeDoctorCertification(doctorInfo, doctorInfo.is_certificated));
        // 2、调用审核接口(成功)
        res = res && !!(await DoctorService.changeDoctorVerification(doctorInfo, true));
        // 2.5、审核完成更新医生信息（账号体系重构后插入的步骤，原来是第一步完成）
        res = res && !!(await DoctorService.changeInstitutionDoctorInfo(doctorInfo));
        // 审核通过就可以加订单
        if (!!res && values.recharge !== undefined) {
          // 3、调用充值订单的接口
          const dataOrder: IDoctorOrderAdd = {
            order_id: UtilDateTime.nowFormat('yyyyMMddhhmmssS'),
            package: values.recharge,
            institution_uuid:doctorInfo.hospital
          };
          res = res && !!(await DoctorService.agentDoctorAddOrder(dataOrder));
        } // 审核驳回 不调用充值订单接口
        if (!!res) {
          // 数据转换
          const orderSetting = pharmacySettingDataHandle(settingData, drugStores);
          // 4、修改医生的配药中心和业务员
          res = res && !!(await DoctorService.updateDoctorDrugStore(doctorInfo, orderSetting.drugStoreUUIDList, values.agent_salesman || ''));
          // 5、修改医生的单元药库设置
          res = res && !!(await MallService.updateCloudPharmacySetting(doctorInfo.buyer_user, orderSetting.cloudSettingData));
          // 修改医生的本地药房设置
          res = res && !!(await MallService.updateLocalPharmacySetting(doctorInfo.buyer_user, orderSetting.localSettingData));
          // 6、修改医生的默认药库设置
          res =
            res &&
            !!(await MallService.updateDoctorMedicineConfig(
              doctorInfo.buyer_user,
              settingData.defaultMedicinePharmacy || null,
              settingData.defaultPrescriptionPharmacy || null
            ));
        }
        if (!!res) {
          message.success(I18N.get('common_submit_success'));
        } else {
          message.error(I18N.get('err_save_failure'));
        }
        this.goback();
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_audit_failure'));
      }
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  /**
   * 审核驳回接口
   * 审核驳回不需要调用其他接口
   * @memberof DoctorDetailForm
   */
  doUnPass = async (doctor: IDoctorInfo, reason: string) => {
    if (this.state.isLoading) {
      return;
    }
    try {
      this.setState({
        isLoading: true,
      });
      const res = await DoctorService.changeDoctorVerification(doctor, false, reason);
      if (res) {
        message.success(I18N.get('common_submit_success'));
      } else {
        message.error(I18N.get('err_audit_failure'));
      }
      this.goback();
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_audit_failure'));
      }
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  /**
   * 认证前先修改数据
   * @param values 修改参数
   */
  doCertificationUpdateDoctorInfo = async (values: any): Promise<boolean> => {
    const { doctorInfo, isAgent, drugStores } = this.props;
    const { settingData } = this.state;
    // 先更新数据
    // 处理处方权相关字段
    const isDoctorUser = doctorInfo.certification_level > 0;
    if (isDoctorUser) {
      doctorInfo.prescription_right = values.prescription_right;
      doctorInfo.superior_institution = values.superior_hospital;
      doctorInfo.cooperative_diagnosis_opened = values.cooperative_diagnosis_opened;
    } else {
      // [学习用户&&业务员] 处方权默认设置false
      doctorInfo.prescription_right = false;
      doctorInfo.superior_institution = null;
    }
    let res = false;
    try {
      if (!!isAgent && !!doctorInfo.id && !!doctorInfo.buyer_user && !!settingData) {
        res = !!(await DoctorService.changeInstitutionDoctorInfo(doctorInfo));
      }
    } catch (e) {
      console.error(e);
    }
    return res;
  };
  /**
   * 待认证调用认证接口
   * @param certId 认证对象主键
   * @memberof DoctorDetailForm
   */
  doCertification = async (isCertified: boolean, reason: string) => {
    if (this.state.isLoading) {
      return;
    }
    try {
      this.setState({
        isLoading: true,
      });
      // await DoctorService.updateAgentDoctorCertification(certId, data);
      const { doctorInfo } = this.props;
      await DoctorService.changeDoctorCertification(doctorInfo, isCertified, reason);
      message.success(I18N.get('common_submit_success'));
      this.goback();
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_audit_failure'));
      }
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  goback = () => {
    if (!!this.props.location.state) {
      const pathname = !!this.props.location.state.isNeedSetting ? RouterConfig.Urls.userDoctorNoSetting : RouterConfig.Urls.userDoctor;
      this.props.history.push({
        pathname: `${pathname}`,
        state: this.props.location.state,
      });
    } else {
      this.props.history.goBack();
    }
  };

  // filterProvinceOption = (input: string, option: any) => {
  //   return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.props.children.indexOf(input) >= 0;
  // };

  /**
   * 获取代理商下有处方权的[机构诊所]
   *
   * @memberof DoctorDetailForm
   */
  getSuperiorSelectOptions = async () => {
    try {
      const prescriptionRightHospitals = await DoctorService.getAllAgentHospitals({ has_prescription_doctor: true });
      if (!!prescriptionRightHospitals && Array.isArray(prescriptionRightHospitals.results)) {
        this.superiorHospitalOptions = prescriptionRightHospitals.results.map((item) => {
          return { label: `${item.name}(${item.phone_no})`, value: item.uuid };
        });
      }
    } catch (error) {
      console.error('getSuperiorSelectOptions', error);
    }
  };

  /**
   * [机构诊所|医生]选择框搜索选项
   *
   * @memberof DoctorDetailForm
   */
  filterSuperiorSelectOption = (input: string, option: any) => {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  /**
   * 药库数据变更时回调
   *
   * @memberof DoctorDetailForm
   */
  settingDataChange = (data: IPharmacySettingData) => {
    this.setState({
      settingData: data,
    });
  };

  render() {
    const { settingData, localSettingData } = this.state;
    const { detailType, isDomestic, rechargeList, doctorInfo, isAgent } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const fullName = doctorInfo.last_name + doctorInfo.first_name;
    const certificationLevel = DoctorService.getCertificationLevel(doctorInfo.certification_level);
    const genderStr = DoctorService.getGender(doctorInfo.gender);
    const workAddress = `${getLocationNameChain(doctorInfo.location_id).join(' ')} ${doctorInfo.work_address}`;

    const applyTime = detailType !== ActionTypes.DOCTOR_TYPE_REJECT ? doctorInfo.created_time : (doctorInfo.reg_time as string);
    const createTime = UtilDateTime.datetimeFormat('yyyy-MM-dd', new Date(applyTime));
    const handlingTime = UtilDateTime.datetimeFormat('yyyy-MM-dd', new Date(doctorInfo.verification_time));
    // 审核驳回详情中 驳回时间取 modified_time
    const rejectTime = UtilDateTime.datetimeFormat('yyyy-MM-dd', new Date(doctorInfo.modified_time));
    const auditStatus = doctorInfo.is_certificated ? I18N.get('common_status_authenticated') : I18N.get('common_status_unauthorized');
    const activeDesc = doctorInfo.is_active ? I18N.get('common_yes') : I18N.get('common_no');
    const passDesc = !!doctorInfo.verification_time ? I18N.get('common_status_pass') : I18N.get('common_reject');
    const rechargeOptions: IRechargeInfo[] = filterRechargeOption(rechargeList, 0);

    // 医生详情页面显示处方权描述
    const prescriptionRightDesc = doctorInfo.prescription_right ? I18N.get('common_have') : I18N.get('common_none');
    // 医生详情显示是否开通云会诊
    const couldConsultation = doctorInfo.cooperative_diagnosis_opened ? I18N.get('common_yes') : I18N.get('common_no');
    // 医生详情页面显示关联的[上级机构诊所|独立医生]描述
    let superiorTypeDesc = '';
    const superiorHospital = this.superiorHospitalOptions.find((item) => item.value === doctorInfo.superior_institution);
    if (superiorHospital) {
      superiorTypeDesc = superiorHospital.label;
    } else {
      superiorTypeDesc = I18N.get('common_none');
    }

    return (
      <div>
        <div className="div-row">
          <div className="div-col-3">&nbsp;</div>
          <div className="div-col-18" style={{ marginBottom: '24px', textAlign: 'right' }}>
            <Button type="primary" onClick={this.goback}>
              {I18N.get('common_back')}
            </Button>
          </div>
          <div className="div-col-3">&nbsp;</div>
        </div>
        <Form onSubmit={this.handleSubmit}>
          <div className="div-row">
            <div className="div-col-3">&nbsp;</div>
            <div className="div-col-18">
              {/* 医生基本信息 */}
              <Row gutter={24} style={{ margin: '0px 0px -24px 0px' }}>
                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('login_userName')} {...formItemLayout}>
                    {getFieldDecorator(`username`, {
                      initialValue: !!doctorInfo ? doctorInfo.username : null,
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('doc_good_at')} {...formItemLayout}>
                    {getFieldDecorator(`good_at`, {
                      initialValue: !!doctorInfo ? doctorInfo.good_at : null,
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('common_name')} {...formItemLayout}>
                    {getFieldDecorator(`name`, {
                      initialValue: fullName || '',
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('doc_account_type')} {...formItemLayout}>
                    {getFieldDecorator(`certification_level`, {
                      initialValue: certificationLevel || '',
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  {isDomestic && (
                    <Form.Item label={I18N.get('common_mobile')} {...formItemLayout}>
                      {getFieldDecorator(`mobile`, {
                        initialValue: !!doctorInfo ? doctorInfo.mobile : null,
                      })(<Input disabled={true} />)}
                    </Form.Item>
                  )}
                  {!isDomestic && (
                    <Form.Item label="email" {...formItemLayout}>
                      {getFieldDecorator(`email`, {
                        initialValue: !!doctorInfo ? doctorInfo.email : null,
                      })(<Input disabled={true} />)}
                    </Form.Item>
                  )}
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('common_gender')} {...formItemLayout}>
                    {getFieldDecorator(`gender`, {
                      initialValue: genderStr || '',
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('doc_work_address')} {...formItemLayout}>
                    {getFieldDecorator(`work_address`, {
                      initialValue: workAddress,
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('doc_position')} {...formItemLayout}>
                    {getFieldDecorator(`position`, {
                      initialValue: !!doctorInfo ? doctorInfo.position : null,
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: 0 }}>
                  <Form.Item label={I18N.get('doc_hospital')} {...formItemLayout}>
                    {getFieldDecorator(`hospital`, {
                      initialValue: !!doctorInfo ? doctorInfo.medical_institution : null,
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>

                {/* 医生资格证书 */}
                {doctorInfo.certification_level !== 4 && (
                  <Col span={12} style={{ padding: 0, position: 'relative' }}>
                    {(doctorInfo.certificate || doctorInfo.certificate2) && (
                      <Form.Item label={I18N.get('doc_certificate')} {...formItemLayout}>
                        {/*第一张医生资格证书*/}
                        {getFieldDecorator(`certificate`, {
                          initialValue: !!doctorInfo ? doctorInfo.certificate : undefined,
                        })(
                          <img
                            alt={I18N.get('doc_certificate')}
                            style={{ width: '100px', height: '100px', objectFit: 'contain', objectPosition: 'top' }}
                            onClick={() => this.openGallery(!!doctorInfo ? doctorInfo.certificate : undefined)}
                            src={!!doctorInfo ? doctorInfo.certificate : undefined}
                          />
                        )}
                      </Form.Item>
                    )}

                    {/* 第二张医生资格证书 */}
                    {doctorInfo.certificate2 && (
                      <Form.Item style={{ position: 'absolute', top: 0, right: 80 }} {...formItemLayout}>
                        {getFieldDecorator(`certificate2`, {
                          initialValue: !!doctorInfo ? doctorInfo.certificate2 : undefined,
                        })(
                          <img
                            alt={I18N.get('doc_certificate')}
                            style={{ width: '100px', height: '100px', objectFit: 'contain', objectPosition: 'top' }}
                            onClick={() => this.openGallery(!!doctorInfo ? doctorInfo.certificate2 : undefined)}
                            src={!!doctorInfo ? doctorInfo.certificate2 : undefined}
                          />
                        )}
                      </Form.Item>
                    )}
                  </Col>
                )}

                {/* 医生身份证 */}
                <Col span={12} style={{ padding: 0, position: 'relative' }}>
                  <Form.Item label={I18N.get('doc_id_card')} {...formItemLayout}>
                    {/* 身份证反面 */}
                    {getFieldDecorator(`id_card`, {
                      initialValue: !!doctorInfo ? doctorInfo.id_card : undefined,
                    })(
                      <img
                        alt={I18N.get('doc_id_card')}
                        style={{ width: '100px', height: '100px', objectFit: 'contain', objectPosition: 'top' }}
                        onClick={() => this.openGallery(!!doctorInfo ? doctorInfo.id_card : undefined)}
                        src={!!doctorInfo ? doctorInfo.id_card : undefined}
                      />
                    )}
                  </Form.Item>

                  {/* 身份证正面 */}
                  {doctorInfo.id_card2 && (
                    <Form.Item style={{ position: 'absolute', top: 0, right: 80 }} {...formItemLayout}>
                      {getFieldDecorator(`id_card2`, {
                        initialValue: !!doctorInfo ? doctorInfo.id_card2 : undefined,
                      })(
                        <img
                          alt={I18N.get('doc_id_card')}
                          style={{ width: '100px', height: '100px', objectFit: 'contain', objectPosition: 'top' }}
                          onClick={() => this.openGallery(!!doctorInfo ? doctorInfo.id_card2 : undefined)}
                          src={!!doctorInfo ? doctorInfo.id_card2 : undefined}
                        />
                      )}
                    </Form.Item>
                  )}
                </Col>
              </Row>

              <Divider dashed={true} />

              {/* 审核等相关字段设置/显示 */}
              <React.Fragment>
                {/* [医生认证|医生审核]页面显示 */}
                {(detailType === ActionTypes.DOCTOR_TYPE_ISPASS || detailType === ActionTypes.DOCTOR_TYPE_ISCERTIFICATED) && (
                  <Row gutter={24} style={{ margin: '0px 0px -24px 0px' }}>
                    {detailType === ActionTypes.DOCTOR_TYPE_ISPASS && isDomestic && (
                      <Col span={12} style={{ padding: 0 }}>
                        <Form.Item label={I18N.get('doc_salesman')} {...formItemLayout}>
                          {getFieldDecorator(`agent_salesman`, {
                            initialValue: !!doctorInfo ? doctorInfo.agent_salesman : undefined,
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                    )}

                    {/* 为之后的推荐人留位置 */}
                    {detailType === ActionTypes.DOCTOR_TYPE_ISPASS && (
                      <Col span={12} style={{ padding: 0 }}>
                        <Form.Item>&nbsp;</Form.Item>
                      </Col>
                    )}

                    {detailType === ActionTypes.DOCTOR_TYPE_ISPASS && (
                      <Col span={12} style={{ padding: 0 }}>
                        <Form.Item label={I18N.get('doc_is_pass')} {...formItemLayout}>
                          {getFieldDecorator(`is_pass`, {
                            rules: [
                              {
                                required: true,
                                message: `${I18N.get('common_choose')}${I18N.get('doc_pass_result')}`,
                              },
                            ],
                          })(
                            <div>
                              <Radio.Group buttonStyle="solid">
                                <Radio.Button value={true}>{I18N.get('common_status_pass')}</Radio.Button>
                                <Radio.Button value={false}>{I18N.get('common_reject')}</Radio.Button>
                              </Radio.Group>
                            </div>
                          )}
                        </Form.Item>
                      </Col>
                    )}

                    {/* 审核通过时显示审核的相关字段 */}
                    {getFieldValue('is_pass') !== 'false' && (
                      <React.Fragment>
                        <Col span={12} style={{ padding: 0 }}>
                          <Form.Item label={I18N.get('doc_is_certificated')} {...formItemLayout}>
                            {getFieldDecorator(`is_certificated`, {
                              rules: [
                                {
                                  required: true,
                                  message: `${I18N.get('common_choose')}${I18N.get('doc_certificated_result')}`,
                                },
                              ],
                            })(
                              <div>
                                <Radio.Group buttonStyle="solid">
                                  <Radio.Button value={true}>{I18N.get('common_status_pass')}</Radio.Button>
                                  <Radio.Button value={false}>{I18N.get('common_reject')}</Radio.Button>
                                </Radio.Group>
                              </div>
                            )}
                          </Form.Item>
                        </Col>

                        {/* 处方权相关内容设置：显示逻辑: 代理商医生用户审核详情 */}
                        {(detailType === ActionTypes.DOCTOR_TYPE_ISPASS || detailType === ActionTypes.DOCTOR_TYPE_ISCERTIFICATED) &&
                          isAgent &&
                          isDomestic &&
                          doctorInfo.certification_level > 0 && (
                            <div>
                              {doctorInfo.certification_level !== 4 && (
                                <Col span={12} style={{ padding: 0 }}>
                                  <Form.Item label={I18N.get('doc_prescription_right')} {...formItemLayout}>
                                    {getFieldDecorator(`prescription_right`, {
                                      initialValue: !!doctorInfo
                                        ? typeof doctorInfo.prescription_right === 'boolean'
                                          ? doctorInfo.prescription_right
                                          : true
                                        : true,
                                      getValueFromEvent: this.checkPrescriptionRight,
                                      rules: [
                                        {
                                          required: true,
                                          message: `${I18N.get('common_choose')}${I18N.get('doc_prescription_right')}`,
                                        },
                                      ],
                                    })(
                                      <Radio.Group buttonStyle="solid">
                                        <Radio.Button value={true}>{I18N.get('common_have')}</Radio.Button>
                                        <Radio.Button value={false}>{I18N.get('common_none')}</Radio.Button>
                                      </Radio.Group>
                                    )}
                                  </Form.Item>
                                </Col>
                              )}
                              <Col span={12} style={{ padding: 0 }}>
                                <Form.Item label={I18N.get('doc_is_could_consultation')} {...formItemLayout}>
                                  {getFieldDecorator(`cooperative_diagnosis_opened`, {
                                    initialValue: !!doctorInfo
                                      ? typeof doctorInfo.cooperative_diagnosis_opened === 'boolean'
                                        ? doctorInfo.cooperative_diagnosis_opened
                                        : false
                                      : false,
                                    // getValueFromEvent: this.checkPrescriptionRight,
                                    rules: [
                                      {
                                        required: true,
                                        message: `${I18N.get('common_choose')}${I18N.get('doc_is_could_consultation')}`,
                                      },
                                    ],
                                  })(
                                    <Radio.Group buttonStyle="solid">
                                      <Radio.Button value={true}>{I18N.get('common_yes')}</Radio.Button>
                                      <Radio.Button value={false}>{I18N.get('common_no')}</Radio.Button>
                                    </Radio.Group>
                                  )}
                                </Form.Item>
                              </Col>
                              {/* {getFieldValue('prescription_right') === false && ( */}
                              {
                                <Col span={12} style={{ padding: 0 }}>
                                  {/* 显示上级机构选择框 */}
                                  <Form.Item label={I18N.get('doc_superior_type')} {...formItemLayout}>
                                    {getFieldDecorator(`superior_hospital`, {
                                      initialValue: !!doctorInfo ? doctorInfo.superior_institution : null,
                                      rules: [
                                        {
                                          required: getFieldValue('cooperative_diagnosis_opened'),
                                          message: `${I18N.get('common_choose')}${I18N.get('doc_superior_institution')}`,
                                        },
                                      ],
                                    })(
                                      <Select
                                        showSearch={true}
                                        filterOption={this.filterSuperiorSelectOption}
                                        placeholder={`${I18N.get('common_choose')}${I18N.get('doc_superior_institution')}`}
                                      >
                                        {this.superiorHospitalOptions.map((r) => {
                                          return (
                                            <Select.Option key={String(r.value)} value={r.value}>
                                              {r.label}
                                            </Select.Option>
                                          );
                                        })}
                                      </Select>
                                    )}
                                  </Form.Item>
                                </Col>
                              }
                            </div>
                          )}

                        {detailType === ActionTypes.DOCTOR_TYPE_ISPASS && (
                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('doc_recharge')} {...formItemLayout}>
                              {getFieldDecorator(`recharge`)(
                                <Select placeholder={`${I18N.get('common_choose')}${I18N.get('doc_recharge')}`}>
                                  {rechargeOptions.map((r) => {
                                    return (
                                      <Select.Option key={r.key} value={r.value}>
                                        {I18N.get(r.key)}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                        )}
                      </React.Fragment>
                    )}

                    {/* 审核驳回时显示审核驳回原因 */}
                    {getFieldValue('is_pass') === 'false' && detailType === ActionTypes.DOCTOR_TYPE_ISPASS && isDomestic && (
                      <Col span={12} style={{ padding: 0 }}>
                        <Form.Item label={I18N.get('common_reject_reason')} {...formItemLayout}>
                          {getFieldDecorator(`reason`, {
                            rules: [
                              {
                                required: true,
                                message: `${I18N.get('common_input')}${I18N.get('common_reject_reason')}`,
                              },
                              {
                                max: 20,
                                message: `${I18N.get('doc_reject_error')}`,
                              },
                            ],
                          })(<Input maxLength={20} placeholder={`${I18N.get('doc_reject_error')}`} />)}
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                )}

                {/* [医生详情 | 审核驳回医生详情]页面显示 */}
                {(detailType === ActionTypes.DOCTOR_TYPE_DETAIL || detailType === ActionTypes.DOCTOR_TYPE_REJECT) && (
                  <Row gutter={24} style={{ margin: '0px 0px -24px 0px' }}>
                    {isDomestic && (
                      <Col span={12} style={{ padding: 0 }}>
                        <Form.Item label={I18N.get('doc_salesman')} {...formItemLayout}>
                          {getFieldDecorator(`agent_salesman`, {
                            initialValue: !!doctorInfo ? doctorInfo.agent_salesman : undefined,
                          })(<Input disabled={true} />)}
                        </Form.Item>
                      </Col>
                    )}

                    {/* 为之后的推荐人留位置 */}
                    <Col span={12} style={{ padding: 0 }}>
                      <Form.Item>&nbsp;</Form.Item>
                    </Col>

                    {/* 显示审核的相关字段 */}
                    <React.Fragment>
                      {/* 审核通过时显示的字段 */}
                      {!!doctorInfo.verification_time && (
                        <React.Fragment>
                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('common_create_time')} {...formItemLayout}>
                              {getFieldDecorator(`create_time`, {
                                initialValue: createTime,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('doc_handling_time')} {...formItemLayout}>
                              {getFieldDecorator(`handling_time`, {
                                initialValue: handlingTime,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('doc_validity_date')} {...formItemLayout}>
                              {getFieldDecorator(`validity_date`, {
                                initialValue: !!doctorInfo ? doctorInfo.valid_time : undefined,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('common_status')} {...formItemLayout}>
                              {getFieldDecorator(`audit_status`, {
                                initialValue: auditStatus,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('doc_enabled')} {...formItemLayout}>
                              {getFieldDecorator(`is_active_desc`, {
                                initialValue: activeDesc,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          {/* 处方权相关内容显示，显示逻辑: 代理商医生用户详情页面 */}
                          {isAgent && isDomestic && doctorInfo.certification_level > 0 && (
                            <div className="ant-col-24" style={{ margin: '0px 0px 30px 0px', border: '1px solid #d9d9d9', backgroundColor: '#f5f5f5' }}>
                              {doctorInfo.certification_level !== 4 && (
                                <Col span={12} style={{ padding: 0 }}>
                                  <Form.Item style={{ margin: 0 }} label={I18N.get('doc_prescription_right')} {...formItemLayout}>
                                    <span className="ant-form-text">{prescriptionRightDesc}</span>
                                  </Form.Item>
                                </Col>
                              )}
                              <Col span={12} style={{ padding: 0 }}>
                                <Form.Item style={{ margin: 0 }} label={I18N.get('doc_is_could_consultation')} {...formItemLayout}>
                                  <span className="ant-form-text">{couldConsultation}</span>
                                </Form.Item>
                              </Col>
                              {/* {doctorInfo.prescription_right === false && ( */}
                              <Col span={12} style={{ padding: 0 }}>
                                <Form.Item style={{ margin: 0 }} label={I18N.get('doc_superior_type')} {...formItemLayout}>
                                  <span className="ant-form-text">{superiorTypeDesc}</span>
                                </Form.Item>
                              </Col>
                              {/* )} */}
                              <a onClick={this.showModal} style={{ position: 'absolute', width: 50, lineHeight: '40px', right: -60 }}>
                                {I18N.get('common_modify')}
                              </a>
                            </div>
                          )}
                        </React.Fragment>
                      )}
                      {/* 审核不通过时显示的字段 */}
                      {!doctorInfo.verification_time && (
                        <React.Fragment>
                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('doc_is_pass')} {...formItemLayout}>
                              {getFieldDecorator(`is_pass_desc`, {
                                initialValue: passDesc,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          {isDomestic && (
                            <Col span={12} style={{ padding: 0 }}>
                              <Form.Item label={I18N.get('common_reject_reason')} {...formItemLayout}>
                                {getFieldDecorator(`reason`, {
                                  initialValue: doctorInfo.reason,
                                })(<Input disabled={true} />)}
                              </Form.Item>
                            </Col>
                          )}

                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('common_create_time')} {...formItemLayout}>
                              {getFieldDecorator(`create_time`, {
                                initialValue: createTime,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>

                          <Col span={12} style={{ padding: 0 }}>
                            <Form.Item label={I18N.get('common_reject_time')} {...formItemLayout}>
                              {getFieldDecorator(`reject_time`, {
                                initialValue: rejectTime,
                              })(<Input disabled={true} />)}
                            </Form.Item>
                          </Col>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  </Row>
                )}
              </React.Fragment>

              {/* 单元药库设置/显示([点击审核驳回按钮|已驳回医生详情页面]不显示) */}
              {detailType !== ActionTypes.DOCTOR_TYPE_REJECT && isDomestic && getFieldValue('is_pass') !== 'false' && (
                <React.Fragment>
                  <Divider dashed={true} />
                  <Row gutter={24} style={{ margin: '0px 0px -24px 0px' }}>
                    <Col span={24} style={{ padding: 0 }}>
                      <PharmacySetting
                        form={this.props.form}
                        isEdit={detailType === ActionTypes.DOCTOR_TYPE_ISPASS}
                        showExtend={false}
                        location={doctorInfo.location_id}
                        settingData={settingData}
                        localSettingData={localSettingData}
                        cbSettingData={this.settingDataChange}
                      />
                    </Col>
                  </Row>
                </React.Fragment>
              )}

              {/* [医生认证|医生审核]页面显示提交按钮 */}
              {(detailType === ActionTypes.DOCTOR_TYPE_ISPASS || detailType === ActionTypes.DOCTOR_TYPE_ISCERTIFICATED) && (
                <Row type="flex" style={{ margin: '24px 0px 0px 0px' }} align="middle" justify="center">
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      {I18N.get('common_submit')}
                    </Button>
                  </Form.Item>
                </Row>
              )}
            </div>
            <div className="div-col-3">&nbsp;</div>
          </div>
        </Form>
        <PswpComponent onRef={this.onRefBind} />
        {/* 处方权修改模态窗 */}
        <Modal
          centered={true}
          title={I18N.get('common_modify')}
          visible={this.state.modalVisible}
          width={600}
          onCancel={this.closeModal}
          destroyOnClose={true}
          footer={null}
        >
          <PrescriptionRightForm
            doctorInfo={doctorInfo}
            superiorHospitalOptions={this.superiorHospitalOptions}
            closeModal={() => this.closeModal()}
            checkPrescriptionRight={(e: RadioChangeEvent) => this.checkPrescriptionRight(e)}
            filterOption={(input: string, option: any) => this.filterSuperiorSelectOption(input, option)}
          />
        </Modal>
      </div>
    );
  }
}

const DoctorDetailPage = Form.create<IDoctorDetailFormProps>()(DoctorDetailForm);
export default DoctorDetailPage;



// WEBPACK FOOTER //
// ./src/components/views/Doctor/DoctorDetailPage.tsx